import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import ThemeProvider from './theme/ThemeProvider';
import { SystemMessagesProvider } from './contexts/SystemMessagesContext';
import { SearchProvider } from './contexts/SearchContext';
import { AuthProvider } from './hooks/useAuth';
import { UserPreferencesProvider } from './contexts/UserPreferencesContext';
import { SocketProvider } from './contexts/SocketContext';
import Router from './router';
import MainLayout from './layout/MainLayout';
import PainelDetalhes from './modules/painelatendimento/PainelDetalhes';

// 🎨 Importar estilos globais para ícones do Material-UI
import './styles/materialIcons.css';

function AppContent() {
  const location = useLocation();
  const isPainelDetalhes = location.pathname === '/painelatendimento/detalhes';

  // Verificar se o usuário está autenticado
  const isAuthenticated = () => {
    try {
      const usuario = localStorage.getItem("usuario");
      const token = localStorage.getItem("token");
      return usuario && token;
    } catch (error) {
      return false;
    }
  };

  // Se for a rota do painel de detalhes, renderizar sem MainLayout
  if (isPainelDetalhes && isAuthenticated()) {
    return <PainelDetalhes />;
  }

  // Caso contrário, usar o fluxo normal
  return isAuthenticated() ? <MainLayout /> : <Router />;
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <SystemMessagesProvider>
          <AuthProvider>
            <UserPreferencesProvider>
              <SocketProvider>
                <SearchProvider>
                  <AppContent />
                </SearchProvider>
              </SocketProvider>
            </UserPreferencesProvider>
          </AuthProvider>
        </SystemMessagesProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
